import * as React from "react";
import { Box, useTheme } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Components
import Header from "./Header";

// Localize
import { useTranslation } from "react-i18next";

// Theme
import { tokens } from "../../theme";

const Faq = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();

  const faqs = t("faq.questions", { returnObjects: true });

  const parseStringWithLinks = (text) => {
    const linkPattern = /\[text:\s*(.+?),\s*url:\s*(.+?)\]/g;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = linkPattern.exec(text)) !== null) {
      // Push plain text before the match
      if (match.index > lastIndex) {
        parts.push(text.slice(lastIndex, match.index));
      }

      // Push the link
      parts.push(
        <a
          key={match[2]}
          href={match[2]}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "blue" }}
        >
          {match[1]}
        </a>
      );

      lastIndex = linkPattern.lastIndex;
    }

    // Push the remaining plain text
    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex));
    }

    return parts;
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title={t("faq.faq")} subtitle={t("faq.faq_description")} />
      </Box>

      {faqs.map((faq, index) => (
        <Accordion key={index} defaultExpanded={true}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography
              variant="h5"
              sx={{
                color: theme.palette.mode === 'dark' ? "#ffffff" : "#000000",
                fontWeight: "bold"
              }}
            >
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>{parseStringWithLinks(faq.answer)}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default Faq;
